import { render, staticRenderFns } from "./DaysRange.vue?vue&type=template&id=a2b60058&"
import script from "./DaysRange.vue?vue&type=script&lang=js&"
export * from "./DaysRange.vue?vue&type=script&lang=js&"
import style0 from "./DaysRange.vue?vue&type=style&index=0&id=a2b60058&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports